import { useState } from "react";

import {
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Modal,
    ModalBody,
    Row
} from "reactstrap";

import PersonIcon from "@mui/icons-material/Person";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";

import { toast } from "react-toastify";

import "./CourseEnquiryModal.css";
import { createEnquiry } from "../../../apiUrlConst";
import { useNavigate } from "react-router-dom";


function CourseEnquiryModal({
    isOpen,
    toggle,
    courseName = "",
    title = "Start Your Learning Journey",
    subtitle = "Fill in your details and our team will get in touch with you shortly."
}) {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        purpose: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);


    /* =========================================
       HANDLE INPUT
    ========================================= */

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    /* =========================================
       RESET FORM
    ========================================= */

    const resetForm = () => {

        setFormData({
            name: "",
            email: "",
            phoneNumber: "",
            purpose: "",
            message: ""
        });
    };


    /* =========================================
       CLOSE MODAL
    ========================================= */

    const handleClose = () => {

        if (loading) {
            return;
        }

        resetForm();

        toggle();
    };


    /* =========================================
       SUBMIT
    ========================================= */

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            setLoading(true);

            const submitData = {
                ...formData,

                purpose:
                    formData.purpose ||
                    (courseName
                        ? `Course Enquiry - ${courseName}`
                        : "General Enquiry")
            };

            await createEnquiry(submitData);


            toast.success(
                "Thank you! Your enquiry has been submitted successfully."
            );

            const submittedCourseName = courseName;
            resetForm();

            toggle();
            navigate("/thankyou", {
                state: {
                    courseName: submittedCourseName,
                },
            });

        } catch (error) {

            console.error(
                "Course enquiry error:",
                error
            );

            toast.error(
                "Unable to submit your enquiry. Please try again."
            );

        } finally {

            setLoading(false);
        }
    };


    return (

        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            centered
            size="lg"
            className="course-enquiry-modal"
        >

            <div className="course-enquiry-wrapper">

                {/* =====================================
                    CLOSE BUTTON
                ===================================== */}

                <Button
                    className="course-enquiry-close"
                    onClick={handleClose}
                    disabled={loading}
                    aria-label="Close"
                    color="secondary"
                    outline
                >
                    <CloseIcon />
                </Button>


                <ModalBody className="p-0">

                    <Row className="g-0">


                        <Col
                            // lg="7"
                            className="course-enquiry-form-col"
                        >

                            <div className="course-enquiry-form-wrapper">

                                <div className="d-flex">



                                </div>


                                <div className="course-enquiry-form-header">

                                    <div className="course-enquiry-form-icon">
                                        <SendIcon />
                                    </div>

                                    <div>
                                        <h3>
                                            Send Your Enquiry
                                        </h3>

                                        <p>
                                            Our Team will contact you shortly.
                                        </p>
                                    </div>



                                </div>


                                <Form onSubmit={handleSubmit}>

                                    <Row>

                                        {/* NAME */}

                                        <Col md="4">

                                            <FormGroup className="course-form-group">



                                                <div className="course-input-wrapper">

                                                    <PersonIcon />

                                                    <Input
                                                        type="text"
                                                        name="name"
                                                        placeholder="Your Name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        required
                                                    />

                                                </div>

                                            </FormGroup>

                                        </Col>


                                        {/* EMAIL */}

                                        <Col md="4">

                                            <FormGroup className="course-form-group">



                                                <div className="course-input-wrapper">

                                                    <EmailOutlinedIcon />

                                                    <Input
                                                        type="email"
                                                        name="email"
                                                        placeholder="Your Email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        required
                                                    />

                                                </div>

                                            </FormGroup>

                                        </Col>


                                        {/* PHONE */}

                                        <Col md="4">

                                            <FormGroup className="course-form-group">



                                                <div className="course-input-wrapper">
                                                    <PhoneOutlinedIcon />

                                                    <Input
                                                        type="tel"
                                                        name="phoneNumber"
                                                        placeholder="Your Phone Number"
                                                        value={formData.phoneNumber}
                                                        onChange={handleChange}
                                                        required
                                                    />

                                                </div>

                                            </FormGroup>

                                        </Col>


                                        {/* PURPOSE */}

                                        {/* <Col md="6">

                                            <FormGroup className="course-form-group">

                                                <Label>
                                                    Purpose
                                                </Label>

                                                <Input
                                                    type="select"
                                                    name="purpose"
                                                    value={formData.purpose}
                                                    onChange={handleChange}
                                                >

                                                    <option value="">
                                                        Select an option
                                                    </option>

                                                    <option value="Training">
                                                        Training
                                                    </option>

                                                    {/* <option value="Course Enquiry">
                                                        Course Enquiry
                                                    </option>

                                                    <option value="Project">
                                                        Project Support
                                                    </option>

                                                    <option value="Consulting">
                                                        Consulting
                                                    </option> 

                                                    <option value="HR">
                                                        Human Resource
                                                    </option>
                                                    <option value="Job">
                                                        Job
                                                    </option>

                                                    <option value="Other">
                                                        Other
                                                    </option>

                                                </Input>

                                            </FormGroup>

                                        </Col> */}


                                        {/* MESSAGE */}

                                        <Col md="12">

                                            <FormGroup className="course-form-group">


                                                <Input
                                                    type="textarea"
                                                    name="message"
                                                    placeholder="Briefly explain your requirements..."
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    rows="4"
                                                    required
                                                />

                                            </FormGroup>

                                        </Col>


                                        {/* SUBMIT */}

                                        <Col md="12">
                                            <div className="d-flex justify-content-center">
                                                <Button className="text-center"
                                                    type="submit"
                                                    color="primary"
                                                    outline
                                                    //className="course-enquiry-submit"
                                                    disabled={loading}
                                                >

                                                    {loading ? (

                                                        <>
                                                            <span
                                                                className="spinner-border spinner-border-sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />

                                                            <span>
                                                                Submitting...
                                                            </span>
                                                        </>

                                                    ) : (

                                                        <>
                                                            <span>
                                                                Submit
                                                            </span>

                                                            {/* <SendIcon /> */}

                                                        </>

                                                    )}

                                                </Button>

                                            </div>

                                        </Col>

                                    </Row>

                                </Form>

                            </div>

                        </Col>

                    </Row>

                </ModalBody>

            </div>

        </Modal>
    );
}


export default CourseEnquiryModal;